export default function formatNumber(value, options) {
    const { currencyFormat, decimalPlaces, removeTrailingZeros, shorten, shortenFormat } = options;

    //save the sign for the original value
    let sign = value >= 0
    value = Math.abs(value)

    // Remove commas from the input value
    if (typeof value === 'string') {
        value = value.replace(/,/g, '');
    }

    // Try to convert the value to a number
    const num = parseFloat(value);
    if (isNaN(num)) {
        return null;
    }

    function shortenNumber(x, format) {
        switch (format) {
            case '1K, 1M, 1B, 1T':
                if (x >= 1e12) return (x / 1e12).toFixed(decimalPlaces) + 'T';
                if (x >= 1e9) return (x / 1e9).toFixed(decimalPlaces) + 'B';
                if (x >= 1e6) return (x / 1e6).toFixed(decimalPlaces) + 'M';
                if (x >= 1e3) return (x / 1e3).toFixed(decimalPlaces) + 'K';
                break;
            case '1K, 1L, 1Cr':
                if (x >= 1e7) return (x / 1e7).toFixed(decimalPlaces) + 'Cr';
                if (x >= 1e5) return (x / 1e5).toFixed(decimalPlaces) + 'L';
                if (x >= 1e3) return (x / 1e3).toFixed(decimalPlaces) + 'K';
                break;
            case '1K, 1M, 1B':
                if (x >= 1e9) return (x / 1e9).toFixed(decimalPlaces) + 'B';
                if (x >= 1e6) return (x / 1e6).toFixed(decimalPlaces) + 'M';
                if (x >= 1e3) return (x / 1e3).toFixed(decimalPlaces) + 'K';
                break;
            default:
                return x.toFixed(decimalPlaces);
        }
        return x.toFixed(decimalPlaces);
    }

    // Determine the currency formatter
    let formattedNumber;
    if (shorten) {
        formattedNumber = shortenNumber(num, shortenFormat);
    } else {
        switch (currencyFormat) {
            case '12,34,567.89':
                formattedNumber = num.toLocaleString('en-IN', { minimumFractionDigits: decimalPlaces, maximumFractionDigits: decimalPlaces });
                break;
            case '1,234,567.89':
                formattedNumber = num.toLocaleString('en-US', { minimumFractionDigits: decimalPlaces, maximumFractionDigits: decimalPlaces });
                break;
            case '1.234.567,89':
                formattedNumber = num.toLocaleString('de-DE', { minimumFractionDigits: decimalPlaces, maximumFractionDigits: decimalPlaces });
                break;
            case '1 234 567,89':
                formattedNumber = num.toLocaleString('fr-FR', { minimumFractionDigits: decimalPlaces, maximumFractionDigits: decimalPlaces }).replace(/\s/g, ' ');
                break;
            default:
                return num;
        }
    }

    // Remove trailing zeros if the option is enabled
    if (removeTrailingZeros) {
        if (decimalPlaces > 0) {
            formattedNumber = formattedNumber.replace(/(\.\d*?[1-9])0+$/g, '$1').replace(/\.0*$/, '');
        }
    }

    return (sign ? "" : "-") + formattedNumber;
}

// Example usage
// const options = {
//     currencyFormat: '12,34,567',
//     decimalPlaces: 2,
//     removeTrailingZeros: true,
//     shorten: true,
//     shortenFormat: '1K, 1L, 1Cr'
// };

// console.log(formatNumber('87654321.999', options));
// console.log(formatNumber(87654321.00, options));
// console.log(formatNumber('abcd', options));
// console.log(formatNumber('1234abc', options));
// console.log(formatNumber('12,34,567', options));
